import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Metallic elements that have a high atomic weight, relatively high
              density and are toxic at low concentration such as mercury (Hg),
              cadmium (Cd), arsenic (As), chromium (Cr), thallium (Tl), lead
              (Pb), etc. are referred as heavy metals. Applications of metals
              include domestic, agricultural, medical and technological with
              wider distribution in the environment. The potential effects on
              human health and the environment have been a concern, which
              necessitates pathways of heavy metals which help in the
              remediation to minimise harmful effects. The soil and water are
              increasingly getting contaminated with heavy metals<sup>1</sup>{" "}
              due to sustained flow of untreated effluents (industries, etc.)
              are damaging the environment. Sources of heavy metals in the
              environment are geogenic, industrial, agricultural,
              pharmaceutical, domestic effluent, etc. Escalated health concerns
              associated with environmental contamination due to heavy metals
              have necessitated remediation measures that are economical and
              technically feasible. Remediation is to avoid all such
              environmental damage. Remediation can be achieved with the help of
              various physico-chemical processes viz., ion-exchange,
              precipitation, reverse osmosis, ultrafiltration, flocculation,
              electro dialysis, etc. But these methods are costly,
              time-consuming, and also not very effective<sup>2</sup>.
            </p>
            <p>&nbsp;</p>
            <p>
              Bioremediation is viable and cost effective approach using of
              microorganisms (bacteria, actinobacteria, fungi, algae and
              yeasts), plant residues or plants to remove heavy metals from
              waste water, industrial effluents, etc.<sup>3,4</sup>.
              Bioremediation is emerging as a green approach for the removal of
              heavy metals and other pollutants from the contaminated land,
              water, etc.
            </p>
            <p>&nbsp;</p>
            <p>
              Phytoremediation is one of the most eco-friendly, economical,
              simple and effective bioremediation options to remove heavy metals
              from the waste water, industrial effluents, etc. In
              phytoremediation, the contaminated soils and water are treated{" "}
              <em>in-situ</em> with the help of plants<sup>5</sup>. The aquatic
              plants are of importance in this regard due to uptake mechanisms
              and rates of these plant, etc.<sup>6,7</sup>.
            </p>
            <p>&nbsp;</p>
            <p>
              Aquatic plants (macrophytes) are important component of wetlands
              <sup>8</sup>, which have the special ability, i.e., adapted to the
              constant contact with surface water and groundwater<sup>9</sup>.
              Macrophytes have thin outer tissues and aerenchyma, through which
              air is distributed to the parts of plant below the surface of the
              water. Macrophytes vegetation has been used in the constructed
              wetlands to treat wastewater by uptake nutrients and heavy metals
              <sup>10</sup>. Macrophytes have a metabolic role in wastewater
              treatment due to their potential to release oxygen into the
              rhizosphere which helps in nitrification and by direct uptake of
              nutrients<sup>11 </sup>as in<em> Typha </em>spp. has a
              considerably high nutrient uptake capacity<sup>12</sup>.&nbsp;
            </p>
            <p>&nbsp;</p>
            <p>
              Aquatic macrophytes are appropriate for metal removal as they can
              tolerate adverse conditions and easier to harvest<sup>13</sup>.
              Wetland plants are divided into emergent, submerged and floating.
              The emergent plants are rooted in the soil with basal portions,
              and leaves, stems and reproductive organs are aerial<sup>14</sup>.
              The examples of emergent plants are <em>Phragmites australis</em>,
              <em> Typha domingensis, Typha latifolia</em>,
              <em> Phragmites karka</em>,<em> Juncus pallidus</em>,
              <em> Empodisma minus</em>, <em>Phalaris arundinacea</em>,{" "}
              <em>Scirpus cyperinus</em>, <em>Aster novae-angliae</em>,{" "}
              <em>Limonium carolinianum</em>, <em>Cephalanthus occidentalis</em>{" "}
              and <em>Rhizophora mangle</em>. Submerged plants are below the
              surface of water for their entire life cycle. The examples of
              submerged plants are <em>Ceratophyllum demersum</em>,{" "}
              <em>Vallisneria americana</em>, <em>Myriophyllum spicatum</em>,{" "}
              <em>Hydrilla verticillata</em>, <em>Heteranthera dubia</em>, etc.
              Submerged species provide more biomass for the uptake and sorption
              of the contaminants through phytoextraction. Submerged plants have
              the ability to accumulate metals in their tissues in comparison to
              rooted emergent plants. In floating plants, the leaves and stems
              float on the surface of water. The examples of floating plants
              include <em>Eichhornia crassipes</em>, <em>Pistia stratiotes</em>,{" "}
              <em>Salvinia herzogii</em>, <em>Wolffia columbiana</em>,{" "}
              <em>Lemna valdiviana</em>, <em>Nymphaea </em>spp.,{" "}
              <em>Nuphar advena</em>, <em>Juncus effusus</em>,{" "}
              <em>Phyllanthus fluitans</em>, etc.<sup>14</sup>.
            </p>
            <p>&nbsp;</p>
            <p>
              The common aquatic plant species (<em>Typha latifolia</em>,
              <em> Myriophyllum exalbescens</em>,<em> Potamogeton epihydrus</em>
              ,<em> Sparganium angustifolium</em>,
              <em> Myriophyllum spicatum</em> and{" "}
              <em>Sparganium multipedunculatum</em>) have been used for
              aluminium (Al) removal<sup>15</sup>. Macrophytes such as Parrot
              feather (<em>Myriophyllum aquaticum</em>), creeping primrose (
              <em>Ludwigia palustris</em>), and water mint (<em>Mentha </em>sp.)
              have been used for removal of iron (Fe), zinc (Zn), copper (Cu),
              and mercury (Hg) from water<sup>16</sup>. The <em>L. minor</em>{" "}
              has been used for removing Cu and cadmium (Cd) from contaminated
              soils<sup>17</sup>.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
